module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-flow-2-6ca5e0c67c2256fbc8186efa0cf8458a.png";